import { TFunction } from 'i18next';

export const STEP_ICON_WIDTH = 30;

export const STEPS_DATA = (t: TFunction) => [
  {
    title: t('payment_in_terminals.step_1.choose_section'),
    substeps: [
      {
        icon: 'emanat.svg',
        title: t('payment_in_terminals.step_1.section_1'),
      },
      {
        icon: 'million.svg',
        title: t('payment_in_terminals.step_1.section_2'),
      },
      {
        icon: 'kapital.svg',
        title: t('payment_in_terminals.step_1.section_3'),
      },
      {
        icon: 'express.svg',
        title: t('payment_in_terminals.step_1.section_4'),
      },
      {
        icon: 'kassam.svg',
        title: t('payment_in_terminals.step_1.section_5'),
      },
      {
        icon: 'kespay.png',
        title: t('payment_in_terminals.step_1.section_6'),
      },
    ],
  },
  { title: t('payment_in_terminals.step_2') },
  { title: t('payment_in_terminals.step_3') },
  { title: t('payment_in_terminals.step_4') },
  { title: t('payment_in_terminals.step_5') },
];

export const OTHER_PAYMENT_OPTIONS = [
  'ABB Mobile',
  'PASHA Mobile Bank',
  'Yelo Bank',
  'Rabitəbank Mobile',
  'ExpressPay Wallet',
  'CIB.az',
];

export const OTHER_ADD_BALANCE_OPTIONS = [
  'ABB Mobile',
  'PASHA Mobile Bank',
  'Yelo Bank',
  'Rabitəbank Mobile',
  'ExpressPay Wallet',
  'E-pul',
  'CIB.az',
];
